<template>
	<span :title="model">
		<v-checkbox
			:hint="hint"
			:label="label"
			:disabled="inputDisabled"
			v-model="model"
			@change="update"
			:rules="computedRules"
			persistent-hint
		>
		</v-checkbox>
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/checkboxInput.vue